var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VTextField',{attrs:{"label":_vm.label,"hint":_vm.hint,"placeholder":_vm.placeholder,"rules":_vm.rules},model:{value:(_vm.notion_url),callback:function ($$v) {_vm.notion_url=$$v},expression:"notion_url"}})}
var staticRenderFns = []

export { render, staticRenderFns }